/**
 * Factory for creating ApplicationService instances based on authentication provider
 */

import AuthenticationProviderEnum from '../../config/authenticationProviderEnum';
import OnecloudApplicationService from './OnecloudApplicationService';
import StratusApplicationService from './StratusApplicationService';
import IApplicationService from './IApplicationService';
import { ApplicationServiceParams } from './types';

/**
 * Parameters for creating ApplicationService strategies
 */
export interface IApplicationServiceFactoryParams
  extends ApplicationServiceParams {
  authenticationProvider: AuthenticationProviderEnum;
}

/**
 * Factory Pattern to encapsulate ApplicationService creation logic
 */
export class ApplicationServiceFactory {
  /**
   * Creates the appropriate ApplicationService based on the authentication provider
   */
  static createService(
    params: IApplicationServiceFactoryParams
  ): IApplicationService {
    const {
      authenticationProvider,
      portalStack,
      clientId,
      appName,
      applicationContext
    } = params;

    const serviceParams: ApplicationServiceParams = {
      portalStack,
      clientId,
      appName,
      applicationContext
    };

    if (authenticationProvider === AuthenticationProviderEnum.coptor) {
      return new OnecloudApplicationService(serviceParams);
    } else {
      return new StratusApplicationService(serviceParams);
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['OnecloudApplicationService', 'StratusApplicationService'];
  }
}
